import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "standard3dDetail"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "desTitle",
  id: "desTitle"
};
const _hoisted_4 = {
  class: "erWeiMaCode",
  ref: "erWeiMaCode"
};
const _hoisted_5 = {
  class: "btnRight"
};
const _hoisted_6 = {
  class: "swiper-container nav",
  id: "nav",
  ref: "swiperNav"
};
const _hoisted_7 = {
  class: "swiper-wrapper"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "btnLeft"
};
const _hoisted_10 = {
  key: 0,
  class: "navText"
};
const _hoisted_11 = {
  class: "nav_bottom"
};
const _hoisted_12 = {
  class: "swiper-container",
  ref: "swipercontainer"
};
const _hoisted_13 = {
  class: "swiper-wrapper"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "nav_list",
  id: "nav_list"
};
const _hoisted_17 = {
  key: 5,
  class: "smallImg"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 6,
  class: "content"
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  key: 7,
  id: "voice",
  ref: "voice",
  preload: "auto"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 8,
  id: "voice",
  ref: "voiceOther",
  preload: "auto"
};
const _hoisted_24 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lsDetailScript = _resolveComponent("lsDetailScript");
  const _component_lsDetail = _resolveComponent("lsDetail");
  const _component_bigImg = _resolveComponent("bigImg");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toIndex && $options.toIndex(...args))
  })) : _createCommentVNode("", true), $data.config.logo ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "logo",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toIndex && $options.toIndex(...args))
  }, [_createElementVNode("img", {
    src: $data.config.logo
  }, null, 8, _hoisted_2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, _toDisplayString($data.detail.name), 1), !$options.isMobile ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "code",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.clickErCode && $options.clickErCode(...args))
  }, [!$data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`erWeiMa ${$data.showBigErCode ? '' : 'activeSmallEr'}`)
  }, "二维码", 2)) : _createCommentVNode("", true), $data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`erWeiMaBig ${!$data.showBigErCode ? 'hideEr' : 'activeEr'}`)
  }, [_createElementVNode("div", _hoisted_4, null, 512), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "erWeiMaName"
  }, [_createTextVNode("扫一扫"), _createElementVNode("br"), _createTextVNode("3D文物带回家~")], -1))], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.columns.length > 1 && !_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "topNav",
    onClick: _cache[3] || (_cache[3] = $event => $options.isMobile ? $data.showNavs = true : ''),
    style: _normalizeStyle($data.showNavs && $options.isMobile ? 'width: 85px' : ''),
    onTouchstart: _cache[4] || (_cache[4] = (...args) => $options.touchstartNav && $options.touchstartNav(...args))
  }, [_withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_vShow, $data.showNavs || !$options.isMobile]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.columns, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide navItem",
      onClick: _withModifiers($event => $options.toColumn(item.columnName, index), ["stop"])
    }, [_cache[10] || (_cache[10] = _createElementVNode("i", null, null, -1)), _createElementVNode("span", null, _toDisplayString(item.columnName), 1)], 8, _hoisted_8);
  }), 256))])], 512), [[_vShow, $data.showNavs || !$options.isMobile]]), _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [[_vShow, $data.showNavs || !$options.isMobile]]), !$data.showNavs && $options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_10, "分类")) : _createCommentVNode("", true)], 36)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_11, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "btnTurnLeft"
  }, null, -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`swiper-slide ${item.code == this.detailCode && item.type == this.detail.type ? 'activeDetail' : ''}`),
      onClick: $event => $options.clickDetail(index, item.m_index)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_15)], 10, _hoisted_14);
  }), 256))])], 512), _cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "btnTurnRight"
  }, null, -1))], 512), [[_vShow, !_ctx.$route.query.hideOthers]]), _createVNode(_component_lsDetailScript), $data.showDetail ? (_openBlock(), _createBlock(_component_lsDetail, {
    key: 4,
    class: _normalizeClass({
      'hidetransparency': $data.showModels[0] && $options.isMobile
    }),
    detailCode: $data.detailCode,
    showModels: $data.showModels,
    isMobile: $options.isMobile,
    ref: "lsDetail",
    activeIndex: $data.activeIndex,
    onHasZhuanti: $options.hasZhuanti,
    onSetParent: $options.setParent
  }, null, 8, ["class", "detailCode", "showModels", "isMobile", "activeIndex", "onHasZhuanti", "onSetParent"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(`nav_item jieshao ${$data.showModels[0] ? 'active' : ''}`),
    onClick: _cache[5] || (_cache[5] = $event => $options.showModel(0))
  }, [...(_cache[13] || (_cache[13] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, "相关介绍", -1)]))], 2), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(`nav_item zhuanti ${$data.showModels[1] ? 'active' : ''}`),
    onClick: _cache[6] || (_cache[6] = $event => $options.showModel(1))
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, "相关专题", -1)]))], 2), [[_vShow, $data.detail.zhuanti]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`nav_item ${$data.showModels[2] ? 'radio' : 'radiono'}`),
    id: "radio",
    onClick: _cache[7] || (_cache[7] = $event => $options.showModel(2))
  }, [_cache[15] || (_cache[15] = _createElementVNode("i", null, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$route.query.fid == 47792 ? '汉语讲解' : '语音讲解'), 1)], 2)) : _createCommentVNode("", true), $data.detail.audioOther ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`nav_item ${$data.showModels[3] ? 'radio' : 'radiono'}`),
    id: "radio",
    onClick: _cache[8] || (_cache[8] = $event => $options.showModel(3))
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, "藏文讲解", -1)]))], 2)) : _createCommentVNode("", true)]), $data.showModels[0] && $options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_18)])) : _createCommentVNode("", true), $data.showModels[0] ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", {
    class: "description",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_20)])) : _createCommentVNode("", true), $data.detail.audio ? (_openBlock(), _createElementBlock("audio", _hoisted_21, [_createElementVNode("source", {
    src: $data.detail.audio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_22)], 512)) : _createCommentVNode("", true), $data.detail.audioOther ? (_openBlock(), _createElementBlock("audio", _hoisted_23, [_createElementVNode("source", {
    src: $data.detail.audioOther,
    type: "audio/mpeg"
  }, null, 8, _hoisted_24)], 512)) : _createCommentVNode("", true), $options.isMobile && $data.showBigImg ? (_openBlock(), _createBlock(_component_bigImg, {
    key: 9,
    imgs: $data.detail.images
  }, null, 8, ["imgs"])) : _createCommentVNode("", true)]);
}